import Vue from 'vue'
import Router from 'vue-router';
Vue.use(Router)
const router = new Router({
    base: 'purchase',
    mode: 'hash',
    routes: [{
        path: '/',
        name: 'index',
        component: () =>
            import('./views/index.vue'),
        meta: {
            title: '首页',
        }
    },{
        path: '/result',
        name: 'result',
        component: () =>
            import('./views/result.vue'),
        meta: {
            title: '结果页',
        }
    },
	]
})
export default router